document.addEventListener("DOMContentLoaded", () => {
  const CartEvents = {
    add: "SCE:add",
    update: "SCE:update",
    change: "SCE:change",
    clear: "SCE:clear",
    mutate: "SCE:mutate",
  };

  const ShopifyCartURLs = [
    "/cart/add",
    "/cart/update",
    "/cart/change",
    "/cart/clear",
  ];

  function isShopifyCartURL(url) {
    if (!url) return false;
    const path = url.split("/").pop();
    return ShopifyCartURLs.includes(`/cart/${path}`);
  }

  function updateType(url) {
    if (!url) return false;
    if (url.includes("cart/add")) {
      return "add";
    } else if (url.includes("cart/update")) {
      return "update";
    } else if (url.includes("cart/change")) {
      return "change";
    } else if (url.includes("cart/clear")) {
      return "clear";
    } else return false;
  }

  function dispatchEvent(type, detail) {
    if (!type) return;
    const eventType = CartEvents[type];
    if (!eventType) return;

    window.dispatchEvent(new CustomEvent(eventType, { detail }));
  }

  function XHROverride() {
    if (!window.XMLHttpRequest) return;

    const originalOpen = window.XMLHttpRequest.prototype.open;
    window.XMLHttpRequest.prototype.open = function () {
      const url = arguments[1];
      this.addEventListener("load", function () {
        if (isShopifyCartURL(url)) {
          try {
            const response = JSON.parse(this.responseText);
            dispatchEvent("mutate", response);
            const type = url.includes("add")
              ? "add"
              : url.includes("update")
              ? "update"
              : url.includes("change")
              ? "change"
              : url.includes("clear")
              ? "clear"
              : "";
            if (type) {
              dispatchEvent(type, response);
            }
          } catch (error) {
            console.error("Error parsing response:", error);
          }
        }
      });
      return originalOpen.apply(this, arguments);
    };
  }

  function fetchOverride() {
    if (!window.fetch || typeof window.fetch !== "function") return;

    const originalFetch = window.fetch;
    window.fetch = function () {
      const url = arguments[0];

      if (isShopifyCartURL(url)) {
        return originalFetch
          .apply(this, arguments)
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            return response
              .clone()
              .json()
              .then((data) => ({ response, data }));
          })
          .then(({ response, data }) => {
            dispatchEvent("mutate", data);
            const type = url.includes("add")
              ? "add"
              : url.includes("update")
              ? "update"
              : url.includes("change")
              ? "change"
              : url.includes("clear")
              ? "clear"
              : "";
            if (type) {
              dispatchEvent(type, data);
            }
            return response;
          })
          .catch((error) => {
            console.error("Fetch error:", error);
            throw error;
          });
      } else {
        return originalFetch.apply(this, arguments);
      }
    };
  }

  fetchOverride();
  XHROverride();
});
